import PropTypes from 'prop-types'

import Moment from 'react-moment'
import classNames from 'classnames'
import { isNullOrUndefinedOrEmpty } from 'utils'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import NoneAnchor from 'components/NoneAnchor'
import Tooltip from '../../../components/tooltip/Tooltip'

const ColumnBasicText = ({ text, title, deleted }) => (
  <td>
    <div className="inner_tbl">
      {deleted && <span className="txt_sort">(삭제)</span>}
      {title ? (
        <Tooltip
          wrapperClassName="txt_limit"
          content={title}
          display="unset"
          nowrap={false}>
          {text}
        </Tooltip>
      ) : (
        <span className="txt_limit">{text}</span>
      )}
    </div>
  </td>
)

ColumnBasicText.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  deleted: PropTypes.bool,
}

const ColumnDate = ({ text, unfold, depthIcon, onUnfold }) => (
  <td>
    <div className="inner_tbl">
      <NoneAnchor
        className={classNames('link_depthitem', { on: !unfold })}
        onClick={onUnfold}>
        <span className="inner_depthitem">
          <Moment format="YYYY-MM-DD">{text}</Moment>
        </span>
        {depthIcon && <span className="ico_comm ico_depth" />}
      </NoneAnchor>
    </div>
  </td>
)

ColumnDate.propTypes = {
  text: PropTypes.string,
  depthIcon: PropTypes.bool,
  unfold: PropTypes.bool,
  onUnfold: PropTypes.func,
}

export const ReportColumnAdGroupName = {
  name: 'adGroupName',
  head: {
    title: '광고그룹',
    minWidth: 187,
  },
  deleted: 'adGroupDeleted',
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnCampaignType = {
  name: 'campaignType',
  head: {
    title: (
      <>
        유형
        <HelpTooltip>
          광고상품을 구분하는 정보로 프리미엄링크와 톡채널검색으로 구분됩니다.
        </HelpTooltip>
      </>
    ),
    minWidth: 161,
  },
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnCampaignName = {
  name: 'campaignName',
  head: {
    title: '캠페인',
    minWidth: 185,
  },
  deleted: 'campaignDeleted',
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnBizChannelName = {
  name: 'bizChannelName',
  head: {
    title: '비즈채널명',
    minWidth: 161,
  },
  deleted: 'bizChannelDeleted',
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnKeyword = {
  name: 'keywordText',
  head: {
    title: (
      <>
        키워드
        <HelpTooltip nowrap={false}>
          프리미엄링크의 검색 매체 지표만 제공하며, 콘텐츠 매체 지표는 포함되지
          않습니다. 톡채널검색은 추후 제공예정입니다.
        </HelpTooltip>
      </>
    ),
    minWidth: 185,
  },
  deleted: 'keywordDeleted',
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnKeywordEx = {
  name: 'keywordEx',
  head: {
    title: '키워드확장',
    minWidth: 185,
  },
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnCreativeName = {
  name: 'creativeName',
  head: {
    title: '소재',
    minWidth: 185,
  },
  deleted: 'creativeDeleted',
  render: props => <ColumnBasicText {...props} />,
}

export const ReportColumnAssetType = {
  name: 'assetType',
  head: {
    title: (
      <>
        확장소재
        <HelpTooltip>
          확장소재의 지표만 보여줍니다.
          <br />
          분석항목:확장소재 보고서 지표의 총 합은 소재 보고서 지표의 총 합과
          일치하지 않을 수 있습니다.
        </HelpTooltip>
      </>
    ),
    minWidth: 185,
  },
  render: props => <ColumnBasicText {...props} />,
}

const TemplateCategoryNames = {
  RECOMMEND: '추천소재',
  CUSTOM: '맞춤소재',
}
export const ReportColumnTemplateCategory = {
  name: 'templateCategory',
  head: {
    title: '소재타입',
    minWidth: 185,
  },
  render: ({ text }) => (
    <td>
      <div className="inner_tbl">
        <span className="txt_limit">
          {isNullOrUndefinedOrEmpty(text)
            ? '전체'
            : TemplateCategoryNames[text]}
        </span>
      </div>
    </td>
  ),
}

export const ReportColumnStartDate = {
  name: 'startDate',
  head: {
    title: '시작일',
    minWidth: 185,
  },
  render: props => <ColumnDate {...props} />,
}

export const ReportColumnEndDate = {
  name: 'endDate',
  head: {
    title: '종료일',
    minWidth: 185,
  },
  render: props => <ColumnDate {...props} />,
}

export const ReportColumnDevice = {
  name: 'userDevice',
  head: {
    title: '디바이스',
    minWidth: 185,
  },
  render: ({ text }) => (
    <td>
      <div className="inner_tbl">
        <span className="txt_limit">
          {isNullOrUndefinedOrEmpty(text) && '전체'}
          {text === 'MOBILE' && '모바일'}
          {text === 'PC' && 'PC'}
        </span>
      </div>
    </td>
  ),
}
const PlacementSideNames = {
  PREMIUM_LINK_SEARCH_PARTNER: '검색 매체 파트너',
  PREMIUM_LINK_SEARCH_KAKAO: '검색 매체 카카오, 다음',
  PREMIUM_LINK_CONTENT_PARTNER: '콘텐츠 매체 파트너',
  PREMIUM_LINK_CONTENT_KAKAO: '콘텐츠 매체 카카오, 다음',
  TALK_CHANNEL_SEARCH_KAKAO: '검색 매체 카카오톡',
}
export const ReportColumnMediaType = {
  name: 'mediaType',
  head: {
    title: (
      <>
        매체유형
        <HelpTooltip>
          검색 매체 카카오톡은 톡채널검색만 제공되며, 프리미엄링크는 제공되지
          않습니다.
        </HelpTooltip>
      </>
    ),
    minWidth: 185,
  },
  render: ({ text, placementSide }) => (
    <td>
      <div className="inner_tbl">
        <span className="txt_limit">
          {isNullOrUndefinedOrEmpty(text) && '전체'}
          {PlacementSideNames[placementSide]}
        </span>
      </div>
    </td>
  ),
}
const TargetingTypeNames = {
  EXACT: '구매 키워드',
  PREFIX: '분절 키워드',
  SUGGEST: '광고 추천 키워드',
}
export const ReportColumnTargetingType = {
  name: 'targetingType',
  head: {
    title: (
      <>
        매칭유형
        <HelpTooltip>톡채널검색만 제공되는 지표입니다.</HelpTooltip>
      </>
    ),
    minWidth: 185,
  },
  render: ({ text }) => (
    <td>
      <div className="inner_tbl">
        <span className="txt_limit">
          {isNullOrUndefinedOrEmpty(text)
            ? '전체'
            : TargetingTypeNames[text] || '-'}
        </span>
      </div>
    </td>
  ),
}

export const ReportColumnHour = {
  name: 'hour',
  head: {
    title: '시간대',
    minWidth: 185,
  },
  render: props => (
    <td>
      <div className="inner_tbl">
        <span className="txt_limit">
          {props.text
            ? `${props.text.padStart(2, '0')}:00~${props.text
                .toString()
                .padStart(2, '0')}:59`
            : '전체'}
        </span>
      </div>
    </td>
  ),
}
